import type React from "react";
import { Badge } from "../../../components/Theme/badge.tsx";
import type { IssueWithAssetRegister } from "../../../kubb";

export function IssueSeverityBadge(props: {
  issue: IssueWithAssetRegister;
}): React.ReactNode {
  return (
    <>
      <Badge color={"red"} className={"lowercase"}>
        Error
      </Badge>
    </>
  );
}
